import { useLingui } from '@lingui/react/macro';

import { InputSelect } from '@/design_system/InputSelect/InputSelect';
import { ArticleConditionForm, useUpdateArticleCondition } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { getQualityControllers } from '@/routes/Requests/New/components/ConditionForm/getQualityControllers';

import { useRequestContext } from '../../../contexts/RequestContext';

export const QualityControllerSelect = ({
  articleConditionForms,
}: {
  articleConditionForms: ArticleConditionForm[];
}) => {
  const { t } = useLingui();

  const { request } = useRequestContext();
  const { article, errors, view, qualityControlFormData } = useArticleContext();

  const { qualityControllers } = getQualityControllers(article, request);

  const conditionForm = qualityControlFormData?.conditionForm;

  const { mutate: updateArticleCondition } = useUpdateArticleCondition({
    requestId: request.id,
    articleId: article.id,
    conditionForm,
  });

  const editableArticleConditionForm = articleConditionForms?.find(
    (articleConditionForm) => !articleConditionForm.completedAt
  );

  const isEditable = view.qualityControl.editable && !!editableArticleConditionForm;

  if (!qualityControllers || !qualityControllers.length || !isEditable) return null;

  const qualityControllersToSelect = qualityControllers.map((controller) => ({
    value: controller,
    label: controller,
  }));

  const isInvalid = errors.qualityControl?.noAnswerer;

  const handleSelectChange = (value: string) => {
    const body = {
      answerer: value,
    };

    updateArticleCondition(body);
  };

  return (
    <InputSelect
      variant="select"
      size="medium"
      style={{ flex: 1 }}
      label={t({
        id: 'requests.articles.quality-control.quality-controller.label',
        message: "Quality controller's name",
      })}
      placeholder={t({
        id: 'requests.articles.quality-control.quality-controller.label',
        message: "Quality controller's name",
      })}
      isSearchable
      value={qualityControllersToSelect.find(
        (opt) => opt.value === editableArticleConditionForm.answerer
      )}
      getOptionValue={(opt) => opt.value}
      getOptionLabel={(opt) => opt.label}
      options={qualityControllersToSelect}
      onChange={(opt) => {
        if (opt?.value !== undefined) {
          handleSelectChange(opt.value);
        }
      }}
      error={
        isInvalid
          ? t({
              id: 'requests.articles.quality-control.quality-controller.error',
              message: 'Please select the quality controller responsible for this quality control',
            })
          : undefined
      }
    />
  );
};
